import * as actionTypes from 'constants/ActionTypes';
import helpers from 'helpers';
import moment from 'moment';
import _ from 'lodash';

const statisticsUsers = (state = {
    items: [],
    isLoaded: false,
    searchText: '',
    from: '',
    until: '',
}, action) => {
    switch (action.type) {
        case actionTypes.GET_STATISTICS_USERS.REQUEST:
            return {
                ...state,
            };
        case actionTypes.GET_STATISTICS_USERS.SUCCESS: {
            let data = action.data;
            let items = [];

            let twoPlusesCollection = [];
            let emailVerifiedCollection = [];
            let havePasswordCollection = [];
            let otherCollection = [];

            data = data.map((item) => {
                item.createdAt = moment(item.createdAt).utc().startOf('day').toDate();
                return item;
            });

            data.forEach((item) => {
                if (item.emailVerified && item.password) {
                    twoPlusesCollection.push(item);
                } else if (item.emailVerified && !item.password) {
                    emailVerifiedCollection.push(item);
                } else if (!item.emailVerified && item.password) {
                    havePasswordCollection.push(item);
                } else {
                    otherCollection.push(item);
                }
            });



            twoPlusesCollection.sort(helpers.sortByDate.apply(this, ['createdAt']));
            emailVerifiedCollection.sort(helpers.sortByDate.apply(this, ['createdAt']));
            havePasswordCollection.sort(helpers.sortByDate.apply(this, ['createdAt']));
            otherCollection.sort(helpers.sortByDate.apply(this, ['createdAt']));

            items = _.concat([], twoPlusesCollection, emailVerifiedCollection, havePasswordCollection, otherCollection);


            // items.sort((a, b) => {
            //     if (a.emailVerified > b.emailVerified) {
            //         return -1;
            //     }
            //
            //     if (a.emailVerified < b.emailVerified) {
            //         return 1;
            //     }
            //
            //     return 0;
            // });

            return {
                ...state,
                items,
                isLoaded: true,
            };
        }
        case actionTypes.GET_STATISTICS_USERS.FAILURE:
            return {
                ...state,
                isLoaded: true,
            };
        case actionTypes.SEARCH_STATISTICS_USERS:
            return {
                ...state,
                searchText: action.searchText,
            };
        default:
            return state;
    }
};

export default statisticsUsers;



// WEBPACK FOOTER //
// ./app/reducers/statistics/users.js